import type {
  EnterpriseCode,
  ProductCode,
  CodePackage,
  TraceCode,
  VerificationLog,
  TraceStatsSummary,
  TraceChainData,
  OrderSummary,
} from '@trace/shared/types';

export const mockOrders: OrderSummary[] = [
  {
    id: 'ord_01',
    orderNumber: 'ORD-20260826-008',
    customerName: '盒马鲜生 · 华北区域五常有机胚芽米中秋定制单',
    enterpriseId: '8001',
    enterpriseName: '五常市金穗生态大米加工有限公司',
    productId: 'prod_01',
    productName: '5kg 有机胚芽米六角真空礼盒装',
    orderQuantity: 2000,
    defaultItemsPerBox: 1,
    deliveryDate: '2026-09-05',
    contactPerson: '王经理 (盒马生鲜采购部)',
    status: 'pending_code',
    createdAt: '2026-08-26T09:00:00Z',
    updatedAt: '2026-08-26T09:00:00Z',
  },
  {
    id: 'ord_02',
    orderNumber: 'ORD-20260825-005',
    customerName: '北京华联精品生活超市 · 双砖家庭装直供订单',
    enterpriseId: '8001',
    enterpriseName: '五常市金穗生态大米加工有限公司',
    productId: 'prod_02',
    productName: '2.5kg 家庭锁鲜装 (双砖真空)',
    orderQuantity: 1500,
    defaultItemsPerBox: 2, // 2袋/盒
    deliveryDate: '2026-09-01',
    contactPerson: '张总监 (华联供应链)',
    status: 'pending_code',
    createdAt: '2026-08-25T11:00:00Z',
    updatedAt: '2026-08-25T11:00:00Z',
  },
  {
    id: 'ord_03',
    orderNumber: 'ORD-20260824-002',
    customerName: '东方甄选 · 嫩江天然富硒生态胚芽米专场定制单',
    enterpriseId: '8002',
    enterpriseName: '齐齐哈尔嫩江绿色农业加工厂',
    productId: 'prod_04',
    productName: '5kg 富硒生态胚芽米牛皮纸复合袋装',
    orderQuantity: 1800,
    defaultItemsPerBox: 1,
    deliveryDate: '2026-08-30',
    contactPerson: '李经理 (选品中心)',
    status: 'in_production',
    createdAt: '2026-08-24T14:30:00Z',
    updatedAt: '2026-08-24T14:30:00Z',
  },
  {
    id: 'ord_04',
    orderNumber: 'ORD-20260830-012',
    customerName: '秋田满满 · 华东母婴渠道2026新米专场定制单',
    enterpriseId: '8003',
    enterpriseName: '秋田满满（杭州）电子商务有限公司',
    productId: 'prod_04',
    productName: '秋田满满 · 婴幼儿有机胚芽稻花香米 300g',
    orderQuantity: 3000,
    defaultItemsPerBox: 6,
    deliveryDate: '2026-09-10',
    contactPerson: '李经理 (供应链部)',
    status: 'in_production',
    createdAt: '2026-08-22T08:00:00Z',
    updatedAt: '2026-08-30T19:00:00Z',
  },
  {
    id: 'ord_05',
    orderNumber: 'ORD-20260829-009',
    customerName: '英式Engnice · 全国高端母婴连锁首批有机米定制单',
    enterpriseId: '8004',
    enterpriseName: '英氏（Engnice）营养食品科技有限公司',
    productId: 'prod_05',
    productName: '英式 · 婴幼儿有机低敏胚芽米 250g',
    orderQuantity: 2500,
    defaultItemsPerBox: 4,
    deliveryDate: '2026-09-08',
    contactPerson: '陈总监 (质控中心)',
    status: 'in_production',
    createdAt: '2026-08-25T09:30:00Z',
    updatedAt: '2026-08-29T18:00:00Z',
  },
];

export const mockEnterpriseCodes: EnterpriseCode[] = [
  {
    id: 'ent_01',
    enterpriseName: '五常市金穗生态大米加工有限公司',
    enterpriseCode: 'MA.156.A1.0058',
    vendorId: 'ent_01',
    vendorName: '北米臻选 · 有机胚芽米',
    status: 'active',
    allocatedQuota: 200000,
    usedQuota: 48600,
    rulePrefix: 'MA.156.A1.0058',
    description: '国家统一赋码体系企业标识段 (五常核心有机基地)',
    createdAt: '2026-01-01T00:00:00Z',
    updatedAt: '2026-08-22T00:00:00Z',
  },
  {
    id: 'ent_02',
    enterpriseName: '齐齐哈尔嫩江绿色农业加工厂',
    enterpriseCode: 'MA.156.A1.0059',
    vendorId: 'ent_02',
    vendorName: '禾本真 · 嫩江富硒生态胚芽米',
    status: 'active',
    allocatedQuota: 100000,
    usedQuota: 12500,
    rulePrefix: 'MA.156.A1.0059',
    description: '嫩江富硒生态胚芽米加工厂专属赋码段',
    createdAt: '2026-02-15T00:00:00Z',
    updatedAt: '2026-08-15T00:00:00Z',
  },
];

export const mockProductCodes: ProductCode[] = [
  {
    id: 'prod_code_01',
    enterpriseCodeId: 'ent_01',
    enterpriseCode: 'MA.156.A1.0058',
    productCode: 'AG.101',
    productName: '5kg 有机胚芽米六角真空礼盒装',
    specName: '5kg 礼盒装',
    weight: 5,
    unit: 'kg',
    organicMark: 'ORG',
    status: 'active',
    createdAt: '2026-01-01T00:00:00Z',
    updatedAt: '2026-08-01T00:00:00Z',
  },
  {
    id: 'prod_code_02',
    enterpriseCodeId: 'ent_01',
    enterpriseCode: 'MA.156.A1.0058',
    productCode: 'AG.102',
    productName: '2.5kg 家庭锁鲜装 (双砖真空)',
    specName: '2.5kg 双砖装',
    weight: 2.5,
    unit: 'kg',
    organicMark: 'ORG',
    status: 'active',
    createdAt: '2026-01-01T00:00:00Z',
    updatedAt: '2026-08-01T00:00:00Z',
  },
  {
    id: 'prod_code_03',
    enterpriseCodeId: 'ent_02',
    enterpriseCode: 'MA.156.A1.0059',
    productCode: 'SE.201',
    productName: '5kg 富硒生态胚芽米牛皮纸复合袋装',
    specName: '5kg 牛皮纸袋',
    weight: 5,
    unit: 'kg',
    organicMark: 'GRN',
    status: 'active',
    createdAt: '2026-02-15T00:00:00Z',
    updatedAt: '2026-08-01T00:00:00Z',
  },
];

export const mockCodePackages: CodePackage[] = [
  {
    id: 'pkg_01',
    packageNumber: 'PKG-20260822-001',
    orderNumber: 'ORD-20260826-008',
    customerName: '盒马鲜生定制单',
    harvestBatchNo: 'PROC-20260822-001',
    enterpriseId: '8001',
    enterpriseName: '五常市金穗生态大米加工有限公司',
    enterpriseCode: 'MA.156.A1.0058',
    productId: 'prod_01',
    productName: '5kg 有机胚芽米六角真空礼盒装',
    productCode: 'AG.101',
    totalQuantity: 2640,
    itemsPerBox: 1,
    totalBoxes: 2640,
    startCode: 'MA.156.A1.0058.AG.101/20260812.ORG.0001',
    endCode: 'MA.156.A1.0058.AG.101/20260812.ORG.2640',
    generatedAt: '2026-08-22T16:30:00Z',
    isDownloaded: true,
    lastDownloadedAt: '2026-08-23T09:15:00Z',
    downloadCount: 3,
    fileSizeBytes: 1845200,
    createdAt: '2026-08-22T16:30:00Z',
    updatedAt: '2026-08-23T09:15:00Z',
  },
  {
    id: 'pkg_02',
    packageNumber: 'PKG-20260825-002',
    orderNumber: 'ORD-20260825-005',
    customerName: '北京华联精品生活超市',
    harvestBatchNo: 'PROC-20260825-002',
    enterpriseId: '8001',
    enterpriseName: '五常市金穗生态大米加工有限公司',
    enterpriseCode: 'MA.156.A1.0058',
    productId: 'prod_02',
    productName: '2.5kg 家庭锁鲜装 (双砖真空)',
    productCode: 'AG.102',
    totalQuantity: 3960,
    itemsPerBox: 2,
    totalBoxes: 1980,
    startCode: 'MA.156.A1.0058.AG.102/20260825.ORG.0001',
    endCode: 'MA.156.A1.0058.AG.102/20260825.ORG.3960',
    generatedAt: '2026-08-25T14:20:00Z',
    isDownloaded: false,
    downloadCount: 0,
    fileSizeBytes: 2758400,
    createdAt: '2026-08-25T14:20:00Z',
    updatedAt: '2026-08-25T14:20:00Z',
  },
  {
    id: 'pkg_03',
    packageNumber: 'PKG-20260826-003',
    orderNumber: 'ORD-20260824-002',
    customerName: '东方甄选专场定制',
    harvestBatchNo: 'PROC-20260826-003',
    enterpriseId: '8002',
    enterpriseName: '齐齐哈尔嫩江绿色农业加工厂',
    enterpriseCode: 'MA.156.A1.0059',
    productId: 'prod_04',
    productName: '5kg 富硒生态胚芽米牛皮纸复合袋装',
    productCode: 'SE.201',
    totalQuantity: 1800,
    itemsPerBox: 1,
    totalBoxes: 1800,
    startCode: 'MA.156.A1.0059.SE.201/20260826.GRN.0001',
    endCode: 'MA.156.A1.0059.SE.201/20260826.GRN.1800',
    generatedAt: '2026-08-26T11:00:00Z',
    isDownloaded: false,
    downloadCount: 0,
    fileSizeBytes: 1256000,
    createdAt: '2026-08-26T11:00:00Z',
    updatedAt: '2026-08-26T11:00:00Z',
  },
  {
    id: 'pkg_04',
    packageNumber: 'PKG-20260830-004',
    orderNumber: 'ORD-20260830-012',
    customerName: '秋田满满 · 华东母婴渠道2026新米专场定制单',
    harvestBatchNo: 'MES-PROC-20260829-003',
    enterpriseId: '8003',
    enterpriseName: '秋田满满（杭州）电子商务有限公司',
    enterpriseCode: 'MA.156.A1.0068',
    productId: 'prod_04',
    productName: '秋田满满 · 婴幼儿有机胚芽稻花香米 300g',
    productCode: 'BB.301',
    totalQuantity: 3000,
    itemsPerBox: 6,
    totalBoxes: 500,
    startCode: 'MA.156.A1.0068.BB.301/20260830.ORG.0001',
    endCode: 'MA.156.A1.0068.BB.301/20260830.ORG.3000',
    generatedAt: '2026-08-30T10:00:00Z',
    isDownloaded: true,
    downloadCount: 2,
    fileSizeBytes: 2150000,
    createdAt: '2026-08-30T10:00:00Z',
    updatedAt: '2026-08-30T10:00:00Z',
  },
];

export const mockTraceCodes: TraceCode[] = [
  {
    id: 'tc_01',
    code: 'MA.156.A1.0058.AG.101/20260812.ORG.0010',
    orderNumber: 'ORD-20260826-008',
    customerName: '盒马鲜生 · 华北区域五常有机胚芽米定制单',
    enterpriseId: 'ent_01',
    enterpriseName: '五常市金穗生态大米加工有限公司',
    enterpriseCode: 'MA.156.A1.0058',
    productId: 'prod_01',
    productName: '5kg 有机胚芽米六角真空礼盒装',
    productCode: 'AG.101',
    landId: 'land_01',
    landName: '五常核心有机基地 · 1号稻田A区',
    processingBatchId: 'batch_01',
    processingBatchNumber: 'PROC-20260822-001',
    itemsPerBox: 1,
    status: 'active',
    queryCount: 3,
    isVerified: true,
    firstQueriedAt: '2026-08-26T10:15:00Z',
    lastQueriedAt: '2026-08-27T08:30:00Z',
    isAuthentic: true,
    generatedAt: '2026-08-22T16:30:00Z',
    createdAt: '2026-08-22T16:30:00Z',
    updatedAt: '2026-08-27T08:30:00Z',
  },
  {
    id: 'tc_02',
    code: 'MA.156.A1.0058.AG.101/20260812.ORG.0011',
    orderNumber: 'ORD-20260826-008',
    customerName: '盒马鲜生 · 华北区域五常有机胚芽米定制单',
    enterpriseId: 'ent_01',
    enterpriseName: '五常市金穗生态大米加工有限公司',
    enterpriseCode: 'MA.156.A1.0058',
    productId: 'prod_01',
    productName: '5kg 有机胚芽米六角真空礼盒装',
    productCode: 'AG.101',
    landId: 'land_01',
    landName: '五常核心有机基地 · 1号稻田A区',
    processingBatchId: 'batch_01',
    processingBatchNumber: 'PROC-20260822-001',
    itemsPerBox: 1,
    status: 'active',
    queryCount: 1,
    isVerified: true,
    firstQueriedAt: '2026-08-27T09:20:00Z',
    lastQueriedAt: '2026-08-27T09:20:00Z',
    isAuthentic: true,
    generatedAt: '2026-08-22T16:30:00Z',
    createdAt: '2026-08-22T16:30:00Z',
    updatedAt: '2026-08-27T09:20:00Z',
  },
  {
    id: 'tc_03',
    code: 'MA.156.A1.0058.AG.101/20260812.ORG.0012',
    orderNumber: 'ORD-20260826-008',
    enterpriseId: 'ent_01',
    enterpriseName: '五常市金穗生态大米加工有限公司',
    enterpriseCode: 'MA.156.A1.0058',
    productId: 'prod_01',
    productName: '5kg 有机胚芽米六角真空礼盒装',
    productCode: 'AG.101',
    landId: 'land_01',
    landName: '五常核心有机基地 · 1号稻田A区',
    processingBatchId: 'batch_01',
    processingBatchNumber: 'PROC-20260822-001',
    itemsPerBox: 1,
    status: 'active',
    queryCount: 0,
    isVerified: false,
    isAuthentic: true,
    generatedAt: '2026-08-22T16:30:00Z',
    createdAt: '2026-08-22T16:30:00Z',
    updatedAt: '2026-08-22T16:30:00Z',
  },
  {
    id: 'tc_04',
    code: 'MA.156.A1.0058.AG.102/20260825.ORG.0088',
    orderNumber: 'ORD-20260825-005',
    customerName: '北京华联生活超市',
    enterpriseId: 'ent_01',
    enterpriseName: '五常市金穗生态大米加工有限公司',
    enterpriseCode: 'MA.156.A1.0058',
    productId: 'prod_02',
    productName: '2.5kg 家庭锁鲜装 (双砖真空)',
    productCode: 'AG.102',
    landId: 'land_01',
    landName: '五常核心有机基地 · 1号稻田A区',
    processingBatchId: 'batch_02',
    processingBatchNumber: 'PROC-20260825-002',
    itemsPerBox: 2,
    status: 'active',
    queryCount: 0,
    isVerified: false,
    isAuthentic: true,
    generatedAt: '2026-08-25T14:20:00Z',
    createdAt: '2026-08-25T14:20:00Z',
    updatedAt: '2026-08-25T14:20:00Z',
  },
  {
    id: 'tc_05',
    code: 'MA.156.A1.0059.SE.201/20260826.GRN.0025',
    orderNumber: 'ORD-20260824-002',
    customerName: '东方甄选专场',
    enterpriseId: 'ent_02',
    enterpriseName: '齐齐哈尔嫩江绿色农业加工厂',
    enterpriseCode: 'MA.156.A1.0059',
    productId: 'prod_04',
    productName: '5kg 富硒生态胚芽米牛皮纸复合袋装',
    productCode: 'SE.201',
    landId: 'land_03',
    landName: '嫩江平原有机基地 · 3号试验田',
    processingBatchId: 'batch_03',
    processingBatchNumber: 'PROC-20260826-003',
    itemsPerBox: 1,
    status: 'active',
    queryCount: 2,
    isVerified: true,
    firstQueriedAt: '2026-08-26T18:40:00Z',
    lastQueriedAt: '2026-08-27T10:10:00Z',
    isAuthentic: true,
    generatedAt: '2026-08-26T11:00:00Z',
    createdAt: '2026-08-26T11:00:00Z',
    updatedAt: '2026-08-27T10:10:00Z',
  },
  {
    id: 'tc_07',
    code: 'MA.156.A1.0068.BB.301/20260830.ORG.0001',
    orderNumber: 'ORD-20260830-012',
    customerName: '秋田满满 · 华东母婴渠道2026新米专场定制单',
    enterpriseId: '8003',
    enterpriseName: '秋田满满（杭州）电子商务有限公司',
    enterpriseCode: 'MA.156.A1.0068',
    productId: 'prod_04',
    productName: '秋田满满 · 婴幼儿有机胚芽稻花香米 300g',
    productCode: 'BB.301',
    landId: 'land_01',
    landName: '五常核心有机基地 · 1号稻田A区',
    processingBatchId: 'batch_04',
    processingBatchNumber: 'MES-PROC-20260829-003',
    itemsPerBox: 6,
    status: 'active',
    queryCount: 1,
    isVerified: true,
    firstQueriedAt: '2026-08-31T10:15:00Z',
    lastQueriedAt: '2026-08-31T10:15:00Z',
    isAuthentic: true,
    generatedAt: '2026-08-30T10:00:00Z',
    createdAt: '2026-08-30T10:00:00Z',
    updatedAt: '2026-08-31T10:15:00Z',
  },
  {
    id: 'tc_08',
    code: 'MA.156.A1.0068.BB.301/20260830.ORG.0018',
    orderNumber: 'ORD-20260830-012',
    customerName: '秋田满满 · 华东母婴渠道2026新米专场定制单',
    enterpriseId: '8003',
    enterpriseName: '秋田满满（杭州）电子商务有限公司',
    enterpriseCode: 'MA.156.A1.0068',
    productId: 'prod_04',
    productName: '秋田满满 · 婴幼儿有机胚芽稻花香米 300g',
    productCode: 'BB.301',
    landId: 'land_01',
    landName: '五常核心有机基地 · 1号稻田A区',
    processingBatchId: 'batch_04',
    processingBatchNumber: 'MES-PROC-20260829-003',
    itemsPerBox: 6,
    status: 'active',
    queryCount: 0,
    isVerified: false,
    isAuthentic: true,
    generatedAt: '2026-08-30T10:00:00Z',
    createdAt: '2026-08-30T10:00:00Z',
    updatedAt: '2026-08-30T10:00:00Z',
  },
];

export const mockVerificationLogs: VerificationLog[] = [
  {
    id: 'vl_01',
    code: 'MA.156.A1.0058.AG.101/20260812.ORG.0010',
    enterpriseName: '五常市金穗生态大米加工有限公司',
    brandName: '北米臻选 · 有机胚芽米',
    productName: '5kg 有机胚芽米六角真空礼盒装',
    batchNumber: 'PROC-20260822-001',
    location: '北京市朝阳区三里屯街道',
    ip: '123.112.45.89',
    queriedAt: '2026-08-27T12:15:00Z',
    isAuthentic: true,
    createdAt: '2026-08-27T12:15:00Z',
    updatedAt: '2026-08-27T12:15:00Z',
  },
  {
    id: 'vl_02',
    code: 'MA.156.A1.0058.AG.101/20260812.ORG.0011',
    enterpriseName: '五常市金穗生态大米加工有限公司',
    brandName: '北米臻选 · 有机胚芽米',
    productName: '5kg 有机胚芽米六角真空礼盒装',
    batchNumber: 'PROC-20260822-001',
    location: '上海市浦东新区陆家嘴金融中心',
    ip: '180.168.22.95',
    queriedAt: '2026-08-27T11:42:00Z',
    isAuthentic: true,
    createdAt: '2026-08-27T11:42:00Z',
    updatedAt: '2026-08-27T11:42:00Z',
  },
  {
    id: 'vl_03',
    code: 'MA.156.A1.0059.SE.201/20260826.GRN.0025',
    enterpriseName: '齐齐哈尔嫩江绿色农业加工厂',
    brandName: '禾本真 · 嫩江富硒生态胚芽米',
    productName: '5kg 富硒生态胚芽米牛皮纸复合袋装',
    batchNumber: 'PROC-20260826-003',
    location: '广东省深圳市南山区高新科技园',
    ip: '113.108.68.14',
    queriedAt: '2026-08-27T10:10:00Z',
    isAuthentic: true,
    createdAt: '2026-08-27T10:10:00Z',
    updatedAt: '2026-08-27T10:10:00Z',
  },
  {
    id: 'vl_04',
    code: 'MA.156.A1.0058.AG.101/20260812.ORG.9999',
    enterpriseName: '未知企业/仿冒来源',
    brandName: '北米臻选 · 有机胚芽米 (仿冒)',
    productName: '5kg 有机胚芽米六角真空礼盒装',
    batchNumber: '未知非法批次',
    location: '广东省广州市天河区石牌街道',
    ip: '116.23.88.12',
    queriedAt: '2026-08-27T09:40:00Z',
    isAuthentic: false,
    anomalyReason: '未在系统数据库备案的非法序列号段 (防伪预警：疑似假冒伪劣)',
    createdAt: '2026-08-27T09:40:00Z',
    updatedAt: '2026-08-27T09:40:00Z',
  },
];

export const mockTraceStatsSummary: TraceStatsSummary = {
  totalCodesGenerated: 128500,
  todayGenerated: 2640,
  totalScanCount: 42180,
  todayScanCount: 865,
  authenticRate: 99.4,
  anomalyCount: 26,
  recentTrends: [
    { date: '08-21', generatedCount: 4000, scanCount: 1450 },
    { date: '08-22', generatedCount: 2640, scanCount: 1380 },
    { date: '08-23', generatedCount: 3200, scanCount: 1620 },
    { date: '08-24', generatedCount: 4500, scanCount: 1750 },
    { date: '08-25', generatedCount: 3960, scanCount: 1910 },
    { date: '08-26', generatedCount: 1800, scanCount: 1840 },
    { date: '08-27', generatedCount: 2640, scanCount: 865 },
  ],
  distributionByProduct: [
    { name: '5kg 有机胚芽米礼盒', value: 68000 },
    { name: '2.5kg 家庭锁鲜装', value: 42500 },
    { name: '5kg 富硒生态米', value: 18000 },
  ],
};

export const sampleFullChainData: TraceChainData = {
  traceCode: 'MA.156.A1.0058.AG.101/20260812.ORG.0010',
  productInfo: {
    brandName: '北米臻选 · 有机胚芽米',
    productName: '5kg 有机胚芽米六角真空礼盒装',
    weight: '5.0 kg',
    shelfLife: '12 个月 (常温避光干燥处)',
    germRetentionRate: '≥ 85.0%',
    organicMark: 'ORG (国家有机产品认证)',
    logoUrl: 'https://images.unsplash.com/photo-1586201375761-83865001e31c?w=200&auto=format&fit=crop&q=80',
  },
  processingInfo: {
    batchNumber: 'PROC-20260822-001',
    processingDate: '2026-08-22 08:30:00',
    workshop: '五常金穗 10万级GMP标准智能加工车间 #02产线',
    yieldRate: 66.0,
    germRetentionRate: 86.4,
    passed: true,
    reportNumber: 'CTI-20260822-R089',
    reportUrl: 'https://images.unsplash.com/photo-1589829545856-d10d557cf95f?w=600&auto=format&fit=crop&q=80',
  },
  farmingInfo: {
    landName: '五常核心有机基地 · 1号稻田A区',
    area: 120,
    manager: '李春山 (基地生产厂长)',
    address: '黑龙江省哈尔滨市五常市安家镇示范区A区',
    harvestDate: '2026-08-20 17:00:00',
    yieldPerMu: 960,
    organicCertNumber: '100OP2200185',
    certExpiryDate: '2026-08-31',
    pesticideCount: 2,
    growthStages: [
      {
        stage: 'seeding',
        name: '恒温育苗',
        date: '2026-04-18',
        description: '恒温浸种催芽，弱碱活水喷灌培育壮秧',
        photos: ['https://images.unsplash.com/photo-1500937386664-56d1dfef3854?w=400&auto=format&fit=crop&q=80'],
      },
      {
        stage: 'transplanting',
        name: '精准插秧',
        date: '2026-05-20',
        description: '机械化精准密植，施入腐熟纯羊粪发酵有机基肥',
        photos: ['https://images.unsplash.com/photo-1592982537447-7440770cbfc9?w=400&auto=format&fit=crop&q=80'],
      },
      {
        stage: 'growing',
        name: '田间生长',
        date: '2026-07-15',
        description: '稻鸭共育生态控草，喷施生物苦参碱绿色防控',
        photos: ['https://images.unsplash.com/photo-1530836369250-ef72a3f5cda8?w=400&auto=format&fit=crop&q=80'],
      },
      {
        stage: 'harvesting',
        name: '金秋收割',
        date: '2026-08-20',
        description: '适期脱水测产，联合收割机颗粒归仓，原粮批次 PADDY-20260820-001',
        photos: ['https://images.unsplash.com/photo-1574943320219-553eb213f72d?w=400&auto=format&fit=crop&q=80'],
      },
    ],
  },
};
